import { Form } from 'semantic-ui-react';
import { Formik, FormikProps, FormikHelpers } from 'formik';
import { validateEmail } from '../../utils/validateEmail';
import './LoginForm.less';

export interface LoginFormFields {
	email: string;
	password: string;
}

export interface LoginFormProps {
	defaultEmail?: string;
	onSubmit: (
		values: LoginFormFields,
		actions: FormikHelpers<LoginFormFields>
	) => void;
	// tslint:disable-next-line:no-any
	onEmailChange?: (e: React.ChangeEvent<any>) => void;
	renderActionButtons?: (isSubmitting: boolean) => React.ReactNode;
	showPassword?: boolean;
	showEmailLoading?: boolean;
}

export const LoginForm: React.FC<LoginFormProps> = ({
	children,
	defaultEmail,
	onSubmit,
	onEmailChange,
	renderActionButtons,
	showPassword,
	showEmailLoading,
}) => {
	return (
		<Formik
			onSubmit={onSubmit}
			initialValues={{
				email: defaultEmail || '',
				password: '',
			}}
			validate={(values: LoginFormFields) => {
				const errors: Partial<LoginFormFields> = {};
				if (!values.email) {
					errors.email = 'Email is required.';
				} else if (!validateEmail(values.email)) {
					errors.email = 'Invalid email address.';
				}
				if (showPassword && !values.password) {
					errors.password = 'Password is required.';
				}
				return errors;
			}}
		>
			{({
				values,
				errors,
				touched,
				handleChange,
				handleBlur,
				handleSubmit,
				isSubmitting,
			}: FormikProps<LoginFormFields>) => (
				<Form className='login-form' onSubmit={handleSubmit}>
					{children}
					<div className='form-fields'>
						<Form.Input
							autoFocus={!defaultEmail}
							fluid
							loading={showEmailLoading}
							label='Your Email'
							type='email'
							name='email'
							placeholder='Email'
							onChange={(e) => {
								handleChange(e);
								if (onEmailChange) {
									onEmailChange(e);
								}
							}}
							onBlur={handleBlur}
							value={values.email}
							error={!!(touched.email && errors.email)}
							required
						/>
						{showPassword !== false && (
							<Form.Input
								autoFocus={defaultEmail}
								fluid
								label='Your Password'
								type='password'
								name='password'
								placeholder='Password'
								onChange={handleChange}
								onBlur={handleBlur}
								value={values.password}
								error={!!(touched.password && errors.password)}
								required
							/>
						)}
					</div>
					{renderActionButtons && renderActionButtons(isSubmitting)}
				</Form>
			)}
		</Formik>
	);
};
